export default __webpack_public_path__ + "static/booking-910d847e9b5cf6dcf21165ca56912b11.png";